export const classSelectors = {
  wrapper: 'react-tag-input',
  input: 'react-tag-input__input',
  tag: 'react-tag-input__tag',
  tagContent: 'react-tag-input__tag__content',
  tagRemove: 'react-tag-input__tag__remove',
  tagRemoveReadOnly: 'react-tag-input__tag__remove-readonly',
};
